module.exports = __webpack_public_path__ + "img/10.d057341c.gif";